export default __webpack_public_path__ + "static/media/BrainBreak cards78.c5e57ba1.png";